"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestCreateUserInvite = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const createUserInviteMutation = (0, graphql_tag_1.default) `
mutation Mutation($workspaceId: ID!, $email: String!, $mergeWith: ID) {
  userInvite(workspace: $workspaceId, email: $email, mergeWith: $mergeWith) {
    created
    email
    expiration
    expired
    id
    resolved
  }
}`;
const requestCreateUserInvite = async (props) => {
    const { data, errors } = await (0, apollo_1.mutate)(createUserInviteMutation, {
        variables: props,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.userInvite;
};
exports.requestCreateUserInvite = requestCreateUserInvite;
